// @flow
export const TRIP_INFORMATION_SET_ADULTS_NUMBER = 'TRIP_INFORMATION_SET_ADULTS_NUMBER';
export const TRIP_INFORMATION_UPDATE_ADULT = 'TRIP_INFORMATION_UPDATE_ADULT';
export const SET_ATTENDEES = 'SET_ATTENDEES';
export const SET_ADULTS = 'SET_ADULTS';

export const DEFAULT_ADULTS_NB = 2;

export const DEFAULT_ADULT_VALUE = {
  birthdate: undefined,
  civility: undefined,
  firstName: undefined,
  lastName: undefined,
  unicodeFirstName: undefined,
  unicodeLastName: undefined,
  neolid: undefined,
};
